/**
 * See the NOTICE file distributed with this work for additional information
 * regarding copyright ownership.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {
  createSlice,
  createAsyncThunk,
  type PayloadAction
} from '@reduxjs/toolkit';

import { getCommittedSpecies } from 'src/content/app/species-selector/state/species-selector-general-slice/speciesSelectorGeneralSelectors';

import type { RootState } from 'src/store';

type State = {
  activeGenomeId: string | null;
};

const initialState: State = {
  activeGenomeId: null
};

export const setDefaultActiveGenomeId = createAsyncThunk(
  'regulatory-activity-viewer-general/set-default-active-genome-id',
  (_, { getState, dispatch }) => {
    const state = getState() as RootState;
    const [firstCommittedSpecies] = getCommittedSpecies(state);
    if (firstCommittedSpecies) {
      dispatch(setActiveGenomeId(firstCommittedSpecies.genome_id));
    }
  }
);

const generalSlice = createSlice({
  name: 'regulatory-activity-viewer-general',
  initialState,
  reducers: {
    setActiveGenomeId(state, action: PayloadAction<string>) {
      state.activeGenomeId = action.payload;
    }
  }
});

export const { setActiveGenomeId } = generalSlice.actions;

export default generalSlice.reducer;
